import { render, staticRenderFns } from "./MenuLaterale.vue?vue&type=template&id=5cb73758&"
import script from "./MenuLaterale.vue?vue&type=script&lang=js&"
export * from "./MenuLaterale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports